import {I18n} from '@aws-amplify/core';
import {Button} from '@mantine/core';
import {useNavigate} from 'react-router-dom';

export const ViewProductsButton = () => {
    const navigate = useNavigate();
    
    return (
        <Button 
            variant="light" 
            size="sm" 
            onClick={() => navigate('/products')}
        >
            {I18n.get('View Products')}
        </Button>
    );
};